import { Component, Input, SimpleChanges } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Discipline, Professional, Provider } from './../../../models';
import { selectDisciplinesSelectedBenefit } from '../../../state/disciplines/disciplines.selectors';
import { StringUtils } from '../../../shared/utils/utils';
import { ConfigService } from '../../../services/config.service';

@Component({
  selector: 'discipline-details-view',
  templateUrl: './discipline-details-view.component.html',
  styleUrl: './discipline-details-view.component.scss',
})
export class DisciplineDetailsViewComponent {
  selectedBenefit$: Observable<string>;
  private subscription = new Subscription();
  @Input() discipline!: Discipline;
  @Input() province!: string;

  issuedEntity: Provider | Professional;

  professionalInternalUrl: string = '';
  resolvedSelectedBenefit!: string;
  dateFormat: string = 'MMMM d, y';
  isProvider: boolean = false;

  constructor(
    private store: Store,
    private router: Router,
    private configService: ConfigService
  ) {
    this.dateFormat = this.configService.getDateFormat();
  }

  ngOnInit(): void {
    this.buildIssuedEntity();
    const benefitSub = this.store
      .select(selectDisciplinesSelectedBenefit)
      .subscribe((benefit) => {
        this.resolvedSelectedBenefit = benefit;
      });

    this.subscription.add(benefitSub);
  }

  generateLinkHtml(url: string, text: string): string {
    return `
      <a href="${url}" target="_blank" rel="noopener" class="document-link-container">
        <img src="assets/images/link-icon.svg" alt="Link Icon" class="document-link-icon" />
        <span>${text}</span>
      </a>
    `;
  }
  
  getDocumentHtml(document: any): string {
    let content = document?.content || document?.title || '';

    if (document?.content && document?.content.startsWith('http')) {
      return this.generateLinkHtml(document.content, content);
    }
    if (document?.url) {
      return this.generateLinkHtml(document.url, content);
    }
    return content;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['discipline']) {
      this.buildIssuedEntity();
    }
  }

  buildIssuedEntity() {
    this.isProvider = !!this.discipline.provider;
    this.issuedEntity = this.isProvider
      ? this.discipline.provider
      : this.discipline.professional;
  }

  searchForIssuedEntity() {
    const queryParams = {
      ben: this.resolvedSelectedBenefit,
      prov: this.province,
      n: this.issuedEntity?.name || this.discipline.name,
      id: this.issuedEntity?.id,
    };

    const path = this.isProvider ? '/providers' : '/professionals';
    this.router.navigate([path], {
      state: { searchFromDisciplines: true },
      queryParams,
    });
  }

  formatUrl(url: string): string {
    return StringUtils.formatUrl(url);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
